<script lang="ts">
	import Icon from '$lib/components/Icon/Icon.svelte';
	import 'swiper/css';
	import 'swiper/css/navigation';
	import type { Post } from '$lib/api/rpc';
	import type { Readable } from 'svelte/store';
	import Tile from '$lib/components/Post/Tile/Tile.svelte';
	import { afterUpdate, onMount } from 'svelte';
	import type { SwiperOptions } from 'swiper/types';
	import { register, type SwiperContainer } from 'swiper/element';
	import { Autoplay } from 'swiper/modules';

	// Register the swiper web component
	register();

	export let posts: Readable<Post[]>;

	let swiperEl: SwiperContainer;

	onMount(() => {
		let properties = {
			loop: true,
			observer: true,
			speed: 750,
			pagination: true,
			...($posts.length && {
				autoplay: {
					pauseOnMouseEnter: true,
					disableOnInteraction: false,
				},
			}),
			// Need to use the Autoplay module in order to get the functionality
			modules: [Autoplay],
		} satisfies SwiperOptions;

		Object.assign(swiperEl, properties);
		swiperEl.initialize();
	});

	afterUpdate(() => {
		if ($posts.length) {
			let autoplay = {
				autoplay: {
					pauseOnMouseEnter: true,
					disableOnInteraction: false,
				},
			};

			Object.assign(swiperEl, autoplay);
			swiperEl.swiper.autoplay.start();
		}
	});
</script>

<div class="swiperWrapper">
	<swiper-container bind:this={swiperEl} init={false}>
		{#each $posts as post, postIndex (post.id)}
			<swiper-slide>
				<Tile {post} {postIndex} parent="carousel" />
			</swiper-slide>
		{/each}
	</swiper-container>
	{#if $posts.length > 1}
		<div id="swiper-button-prev">
			<Icon
				icon="left-chevron"
				size={'30'}
				onClick={() => {
					if (swiperEl && 'swiper' in swiperEl) {
						// @ts-ignore
						swiperEl.swiper.slidePrev();
					}
				}}
			/>
		</div>
		<div id="swiper-button-next">
			<Icon
				icon="right-chevron"
				size={'30'}
				onClick={() => {
					if (swiperEl && 'swiper' in swiperEl) {
						// @ts-ignore
						swiperEl.swiper.slideNext();
					}
				}}
			/>
		</div>
	{/if}
</div>

<style>
	:global(#pageContainer[dir='rtl']) {
		--directionSwiper: rtl;
	}

	:global(#pageContainer[dir='ltr']) {
		--directionSwiper: ltr;
	}

	.swiperWrapper {
		position: relative;
		margin-block: 50px var(--gutterMedium);
		direction: var(--directionSwiper);
	}

	#swiper-button-prev {
		position: absolute;
		inset-inline-start: -40px;
		inset-block-end: 50%;
	}

	#swiper-button-next {
		position: absolute;
		inset-inline-end: -40px;
		inset-block-end: 50%;
	}

	/* Reversing arrow icons in RTL  */
	:global(#pageContainer[dir='rtl'] #swiper-button-next .px-icon-right-chevron::before) {
		content: '\E801';
	}

	:global(#pageContainer[dir='rtl'] #swiper-button-prev .px-icon-left-chevron::before) {
		content: '\E61d';
	}
</style>
